import React from 'react';

import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ClickableContainer } from 'components/clickable-container';
import ArrowBack from 'components/icons/arrow-back';

const Arrow = styled(ArrowBack)`
  height: 18px;
  width: 16px;
  fill: ${p => p.color};
  margin: 1rem;
  ${Styles.desktop`
    display: none;
  `}
`;

const ContainerNoDecoration = styled(ClickableContainer)`
  padding: 0 10px;
  position: fixed;
  z-index: ${Styles.zIndex.overlay};
  top: calc(3px + env(safe-area-inset-top));
  left: 3px;
  ::before {
    color: transparent;
  }
  &:active,
  &:hover,
  &:link,
  &:visited {
    color: inherit;
  }
`;

const LinkNoDecoration = styled(Link)`
  padding: 0 10px;
  position: fixed;
  z-index: ${Styles.zIndex.overlay};
  top: calc(3px + env(safe-area-inset-top));
  left: 3px;
  ::before {
    color: transparent;
  }
  &:active,
  &:hover,
  &:link,
  &:visited {
    color: inherit;
  }
`;

export const BackArrowLink = ({ to, color }: { to: string; color: string }) => {
  return (
    <LinkNoDecoration to={to}>
      <Arrow color={color} />
    </LinkNoDecoration>
  );
};

export const BackArrowHistory = ({ color }: { color: string }) => {
  return (
    <ContainerNoDecoration onClick={() => window.history.back()}>
      <Arrow color={color} />
    </ContainerNoDecoration>
  );
};
